import { render } from "./develop.vue?vue&type=template&id=2e4ddaa6&scoped=true"
import script from "./develop.vue?vue&type=script&lang=js"
export * from "./develop.vue?vue&type=script&lang=js"

import "./develop.vue?vue&type=style&index=0&id=2e4ddaa6&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4ddaa6"]])

export default __exports__